import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import CouplePatientInfo from '../../Components/Global_Components/common/CouplePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './postIUISheet.scss';

export default function PostIUISheet(props) {
  const [showTables, setShowTables] = useState({
    medication: true
  });
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const [formData, setFormData] = useState({
    triggerDate: '',
    triggerTime: '',
    iuiDate: '',
    iuiTime: '',
    protocolUsed: '',
    sitting: '',
    spermPreparationMethod: '',
    iuiCycleDay: '',
    noOfFollicles: '',
    endometrialThickness: '',
    follicleStatus: '',
    iuiNotes_doneUnderStrictAsepticPrecautions: true,
    cannulation: {
      easy: false,
      difficult: false,
      allisUsed: false,
      styletUsed: false
    },
    andrologyTechnician: '',
    doubleWitnessing: '',
    tmsc: '',
    uptDate: '',
    advice: ''
  });

  const [medicationRows, setMedicationRows] = useState([
    {sno: '1', drug: 'T. Folvista', genericName: 'Folic Acid + Methylcobalamin + DHA', dosage: '1 tab', freq: '0-0-1', route: 'Oral', timing: '9 PM', withFood: 'Yes', duration: '15'},
    {sno: '2', drug: 'T. Dydrofirst / Dydroboon', genericName: 'Dydrogesterone', dosage: '10 mg', freq: '1-1-1', route: 'Oral', timing: '8 AM- 3PM-8PM', withFood: 'Yes', duration: '15'},
    {sno: '3', drug: 'T. C Vit / Celin', genericName: 'Vitamin C', dosage: '500 mg', freq: '1-0-1', route: 'Oral', timing: 'After food', withFood: 'Yes', duration: '30'},
    {sno: '4', drug: 'T. Neuroplex / Neurobion', genericName: 'Vitamin B-complex', dosage: '1 tab', freq: 'OD', route: 'Oral', timing: 'After food', withFood: 'Yes', duration: '30'},
    {sno: '5', drug: 'Tab. Ecosprin 75/150', genericName: 'Aspirin (Low Dose)', dosage: '-', freq: '0-0-1', route: 'Oral', timing: 'in the night after meal', withFood: 'Yes', duration: '15'},
    {sno: '6', drug: 'Cap. Gestobond', genericName: 'Micronized Progesterone', dosage: '400 mg', freq: '1-0-1', route: 'Vaginal', timing: '9AM&9PM', withFood: '-', duration: '15'},
    {sno: '7', drug: 'Promyse Gel', genericName: 'Progesterone Vaginal Gel', dosage: '90 mg', freq: '1-0-1', route: 'Vaginal', timing: '9AM&9PM', withFood: '-', duration: '15'}
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S.No'},
    {key: 'drug', label: 'Medication (Brand Name)'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'timing', label: 'Timing'},
    {key: 'withFood', label: 'With Food'},
    {key: 'duration', label: 'Days'}
  ];

  const handleChange = (e, fieldName) => {
    if (e && e.target) {
      const {name, value, type, checked} = e.target;
      const val = type === 'checkbox' ? checked : value;
      setFormData({...formData, [name]: val});
    } else {
      setFormData({...formData, [fieldName]: e});
    }
  };

  const handleCheckboxChange = e => {
    const {name, checked} = e.target;
    setFormData(prevState => ({
      ...prevState,
      cannulation: {
        ...prevState.cannulation,
        [name]: checked
      }
    }));
  };

  const handlesubmit = () => {
    try {
      if (props.patientsData.id && props.patientsData.p_uhid) {
        setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('postIUISheetReportWrap').innerHTML;
          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              couple_id: formData.coupleId || props.patientsData?.couple_id || '',
              description: '',
              template_type: 'Post IUI Sheet'
            }
          };
          props.loaderchange(true);
          const response = await dispatch(postPrescriptionTemplate(payload));
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange(false);
            Swal.fire('Error', 'Network error, please try again.', 'error');
          }
        }, 3000);
      } else {
        Swal.fire('Error', 'Please enter a valid patient ID.', 'error');
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  const renderCannulation = () => {
    return Object.keys(formData.cannulation)
      .filter(key => formData.cannulation[key])
      .map(key => key.replace(/([A-Z])/g, ' $1').trim())
      .join(', ');
  };

  return (
    <div id='PostIUISheet'>
      <div className='PostIUISheet'>
        <img src={headerimage} alt='header' style={{width: '100%'}} />
        <h2 style={{textAlign: 'center'}}>POST IUI SHEET – ASCAS Fertility Care</h2>
        <CouplePatientInfo
          patientsData={props.patientsData}
          show={show}
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          loaderchange={props.loaderchange}
        />

        <div className='detail-section'>
          <h4>📅 Cycle Details</h4>
          <div className='row'>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Trigger Date:' name='triggerDate' type='date' value={formData.triggerDate} onChange={handleChange} />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Time:' name='triggerTime' type='time' value={formData.triggerTime} onChange={handleChange} />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='IUI Date:' name='iuiDate' type='date' value={formData.iuiDate} onChange={handleChange} />
            </div>
            <div className='col-md-6'>
              <ReportFormInputWithLabel label='Time:' name='iuiTime' type='time' value={formData.iuiTime} onChange={handleChange} />
            </div>
          </div>
        </div>

        <div className='detail-section'>
          <h4>📋 Stimulation Protocol</h4>
          <div className='row'>
            <div className='col-md-5'>
              <SelectField
                label='Protocol Used'
                name='protocolUsed'
                value={formData.protocolUsed}
                onChange={e => handleChange(e, 'protocolUsed')}
                options={['Natural Cycle', 'Letrozole 5 mg + GT', 'Letrozole 2.5 mg + GT', 'Only GT (Gonadotropin)', 'Letrozole 5 Days', 'Letrozole 10 Days', 'Low-Dose hCG'].map(o => ({
                  label: o,
                  value: o
                }))}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Sitting'
                name='sitting'
                value={formData.sitting}
                onChange={e => handleChange(e, 'sitting')}
                options={['Single', 'Double'].map(o => ({label: o, value: o}))}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Sperm Preparation Method'
                name='spermPreparationMethod'
                value={formData.spermPreparationMethod}
                onChange={e => handleChange(e, 'spermPreparationMethod')}
                options={['Density Gradient + Swim-Up', 'Swim-Up Only', 'microfluidics'].map(o => ({label: o, value: o}))}
                placeholder='Please select'
              />
            </div>
          </div>
        </div>

        <div className='detail-section'>
          <h4>🩺 IUI Procedure Summary</h4>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='IUI Cycle Day:' name='iuiCycleDay' value={formData.iuiCycleDay} onChange={handleChange} />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='No. of Follicles:' name='noOfFollicles' value={formData.noOfFollicles} onChange={handleChange} />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Endometrial Thickness (mm):' name='endometrialThickness' value={formData.endometrialThickness} onChange={handleChange} minWidth='180px' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Follicle Status'
                name='follicleStatus'
                value={formData.follicleStatus}
                onChange={e => handleChange(e, 'follicleStatus')}
                options={['Ruptured', 'Not Ruptured'].map(o => ({label: o, value: o}))}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label className='fw-bold' style={{width: '180px'}}>
              IUI Notes:
            </label>
            <div className='form-check'>
              <input
                className='form-check-input'
                type='checkbox'
                name='iuiNotes_doneUnderStrictAsepticPrecautions'
                checked={formData.iuiNotes_doneUnderStrictAsepticPrecautions}
                onChange={handleChange}
              />
              <label className='form-check-label'>Done under strict aseptic precautions</label>
            </div>
          </div>
          <div className='d-flex align-items-start py-2'>
            <label className='fw-bold' style={{width: '180px'}}>
              Cannulation:
            </label>
            <div>
              <div className='form-check form-check-inline'>
                <input className='form-check-input' type='checkbox' name='easy' checked={formData.cannulation.easy} onChange={handleCheckboxChange} />
                <label className='form-check-label'>Easy</label>
              </div>
              <div className='form-check form-check-inline'>
                <input className='form-check-input' type='checkbox' name='difficult' checked={formData.cannulation.difficult} onChange={handleCheckboxChange} />
                <label className='form-check-label'>Difficult</label>
              </div>
              <div className='form-check form-check-inline'>
                <input className='form-check-input' type='checkbox' name='allisUsed' checked={formData.cannulation.allisUsed} onChange={handleCheckboxChange} />
                <label className='form-check-label'>Allis Used</label>
              </div>
              <div className='form-check form-check-inline'>
                <input className='form-check-input' type='checkbox' name='styletUsed' checked={formData.cannulation.styletUsed} onChange={handleCheckboxChange} />
                <label className='form-check-label'>Stylet Used</label>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Andrology Technician'
                name='andrologyTechnician'
                value={formData.andrologyTechnician}
                onChange={e => handleChange(e, 'andrologyTechnician')}
                options={['Sebastian', 'Karthik', 'Siva'].map(o => ({label: o, value: o}))}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Double Witnessing'
                name='doubleWitnessing'
                value={formData.doubleWitnessing}
                onChange={e => handleChange(e, 'doubleWitnessing')}
                options={['Done', 'Not Done'].map(o => ({label: o, value: o}))}
                placeholder='Please select'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='TMSC (million):' name='tmsc' value={formData.tmsc} onChange={handleChange} minWidth='180px' />
            </div>
          </div>
        </div>

        <div className='detail-section'>
          <h4>💡Post-IUI Instructions</h4>
          <ul>
            <li>✅ You may resume all routine work: climbing stairs, intercourse, Indian toilets allowed</li>
            <li>✅ Eat homemade food, all fruits and vegetables</li>
            <li>❌ Avoid junk foods, oily/spicy foods, and sweets</li>
            <li>✅ Intercourse is not restricted; 2 days of intercourse after IUI may improve success</li>
            <li class='d-flex align-items-center gap-2'>
              <label class='me-2'>🧪 Do home pregnancy test (UPT) on:</label>
              <input name='uptDate' type='date' value={formData.uptDate} onChange={handleChange} />
            </li>

            <li>📺 Watch Dr. Aishwarya’s videos on IUI for guidance and reassurance – available on YouTube (search: Dr. Aishwarya IUI ASCAS)</li>
          </ul>
        </div>

        {showTables.medication && (
          <TemplateTable
            id='medication'
            title='💊 Medications – Post IUI'
            headers={medicationHeaders}
            rows={medicationRows}
            onRowsChange={(id, newRows) => setMedicationRows(newRows)}
            enableActions={true}
            onNill={() => handleNill('medication', setShowTables)}
          />
        )}

        <div className='d-flex align-items-start py-2'>
          <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>
            ADVICE:
          </label>
          <textarea className='Textarea' placeholder='ADVICE' id='advice' name='advice' onChange={handleChange} rows='4' cols='100'></textarea>
        </div>

        <p className='pt-3' style={{fontWeight: '600'}}>
          NEXT Appointment - <input name='nextAppointment' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
        </p>

        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>

      <div id='postIUISheetReport'>
        <div id='postIUISheetReportWrap'>
          <Headers />
          <p className='Dani'></p>

          {/* Patient Information — same layout as FertilityFirstVisit */}
          <div
            className='firstPartner'
            style={{
              border: '1px solid black',
              borderRadius: '10px',
              marginBottom: '10px'
            }}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
              {renderReportfield('Patient Name:', formData.coupleId ? formData.patientName1 : `${props.patientsData.titles || ''} ${props.patientsData.first_name || ''} ${props.patientsData.last_name || ''}`, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Patient ID:', formData.coupleId ? formData.patientId1 : props.patientsData.p_uhid, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Gender :', formData.coupleId ? formData.gender1 : props.patientsData.gender, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
              {renderReportfield('Age :', formData.coupleId ? formData.age1 : props.patientsData.age, {
                styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                styleLabel: {fontWeight: '600', marginRight: '5px'}
              })}
            </div>
          </div>
          {formData.coupleId && (
            <div className='secondPartner' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '5px'}}>
              <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '10px'}}>
                {renderReportfield('Patient Name:', formData.patientName2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
                {renderReportfield('Patient ID:', formData.patientId2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
                {renderReportfield('Gender :', formData.gender2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
                {renderReportfield('Age :', formData.age2, {
                  styleSec: {margin: '0 80px 10px 10px', display: 'flex'},
                  styleLabel: {fontWeight: '600', marginRight: '5px'}
                })}
              </div>
            </div>
          )}

          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>POST IUI SHEET – ASCAS Fertility Care</h4>
          </div>
          <div style={{marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>📅 Cycle Details</h6>
            <div style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Trigger Date:', formData.triggerDate)}
              {renderReportfield('Time:', formData.triggerTime)}
              {renderReportfield('IUI Date:', formData.iuiDate)}
              {renderReportfield('Time:', formData.iuiTime)}
            </div>
          </div>
          <div style={{marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>📋 Stimulation Protocol</h6>
            <div style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Protocol Used:', formData.protocolUsed)}
              {renderReportfield('Sitting:', formData.sitting)}
              {renderReportfield('Sperm Preparation Method:', formData.spermPreparationMethod)}
            </div>
          </div>
          <div style={{marginTop: '10px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>🩺 IUI Procedure Summary</h6>
            <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
              {renderReportfield('IUI Cycle Day:', formData.iuiCycleDay)}
              {renderReportfield('No. of Follicles:', formData.noOfFollicles)}
              {renderReportfield('Endometrial Thickness:', `${formData.endometrialThickness} mm`)}
              {renderReportfield('Follicle Status:', formData.follicleStatus)}
              {formData.iuiNotes_doneUnderStrictAsepticPrecautions && renderReportfield('IUI Notes:', 'Done under strict aseptic precautions')}
              {renderReportfield('Cannulation:', renderCannulation())}
              {renderReportfield('Andrology Technician:', formData.andrologyTechnician)}
              {renderReportfield('Double Witnessing:', formData.doubleWitnessing)}
              {renderReportfield('TMSC:', `${formData.tmsc} million`)}
            </div>
          </div>

          <div style={{display: 'flex', marginTop: '5px'}}>
            <h6 style={{fontWeight: 600, marginRight: '5px'}}>💡Post-IUI Instructions</h6>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <div style={{paddingLeft: '20px'}}>
              {[
                '✅ You may resume all routine work: climbing stairs, intercourse, Indian toilets allowed',
                '✅ Eat homemade food, all fruits and vegetables',
                '❌ Avoid junk foods, oily/spicy foods, and sweets',
                '✅ Intercourse is not restricted; 2 days of intercourse after IUI may improve success',
                `🧪 Do home pregnancy test (UPT) on: ${formData.uptDate?.split('-').reverse().join('-')}`,
                '📺 Watch Dr. Aishwarya’s videos on IUI for guidance and reassurance – available on YouTube (search: Dr. Aishwarya IUI ASCAS)'
              ].map((item, index) => (
                <div key={index} style={{marginBottom: '5px'}}>
                  {item}
                </div>
              ))}
            </div>
          </div>

          {showTables.medication &&
            renderDynamicTable(
              '💊 Medications – Post IUI',
              medicationHeaders.map(h => h.label),
              medicationHeaders.map(h => h.key),
              medicationRows
            )}

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice}</pre>
          </div>

          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Appointment : ', formData.nextAppointment?.split('-').reverse().join('-'))}</div>
          </div>
          <p className='Dani'></p>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
